<template lang="html">
<div class="table-row table-rowbg">
  <div class="table-td w200">
   {{payment.order.order_number}}
  </div>
  <div class="table-td w200">
  {{(payment.delivery_type ===1) ? 'FTL' : 'PTL'}}
  </div>
  <div class="table-td w200">
   {{payment.vehicle_type.name}}
  </div>
  <div class="table-td w300">
  {{payment.depot.name}}
  </div>
  <div class="table-td summary-action">
  {{ calculateIndentTotal }}
  </div>
</div>
</template>
<script>
export default {
  props: {
    payment: {
      type: Object,
    },
  },
  components: {},
  computed: {
    isApproved() {
      return (this.$store.invoice && this.$store.invoice.status) ?
        this.$store.invoice.status >= 3 : false;
    },
    calculateIndentTotal() {
      const section = (this.isApproved) ? 'client' : 'transporter';
      return this.payment.charges.reduce((total, value) => {
        return (total + Number(value.total_amount[section].toFixed(2)))
      }, 0)
    }
  },
};
</script>

<style lang="scss">

</style>
